import React from "react";

const Navigation = () => (
  <nav>
    <h1>nav</h1>
  </nav>
);

export default Navigation;
